import { BASE_URL } from "server";
import { formatSchoolClassInText } from "components/common/schoolClass";

export interface Conversation {
  _id: string;
  memberIds: string[];
  conversationType: string;
  title: string;
  unreadMessagesCount: number;
  isActivated: boolean;
  lastMessage: {
    _id: string;
    conversationId: string;
    senderId: string;
    body: string;
    fileIds: string[];
    type: string;
    timestamp: string;
    readByMembers: string[];
    archived: boolean;
    isAnswerActivated: boolean;
    __v: number;
  };
  updatedAt: string;
  supervisorId?: string;
  correctorId?: string;
}

export async function getConversations(type: string): Promise<Conversation[]> {
  const response = await fetch(
    `${BASE_URL}/conversations/mine?conversationType=${type}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    },
  );

  if (!response.ok) {
    throw new Error(
      `HTTP error! status: ${response.status}, message : ${response.body}`,
    );
  }

  const fetchedConversations = await response.json();
  const conversations: Conversation[] = [];
  fetchedConversations.forEach((fetchedConversation: any) => {
    const conversation: Conversation = {
      _id: fetchedConversation._id,
      memberIds: fetchedConversation.memberIds,
      conversationType: fetchedConversation.conversationType,
      title: formatSchoolClassInText(fetchedConversation.title),
      unreadMessagesCount: fetchedConversation.unreadMessagesCount,
      lastMessage: fetchedConversation.lastMessage,
      updatedAt: fetchedConversation.updatedAt,
      isActivated: fetchedConversation.isActivated,
      supervisorId: fetchedConversation.supervisorId,
      correctorId: fetchedConversation.correctorId,
    };
    conversations.push(conversation);
  });

  // Trier les conversations par plus récent (updatedAt décroissant)
  return conversations.sort((a, b) => {
    const dateA = new Date(a.updatedAt).getTime();
    const dateB = new Date(b.updatedAt).getTime();
    return dateB - dateA; // Ordre décroissant (plus récent en premier)
  });
}
